const activeClass = 'active';

window.ui = {
    init() {
        this.sidebarContainer = document.querySelector('.sidebar__content');
        this.sidebarPreloader = document.querySelector('.sidebar .sidebar__preloader');
        this.configurator = document.querySelector('.configurator');
        this.main = document.querySelector('.main');
        this.step = 1;
        this.steps = this.sidebarContainer.querySelectorAll('.steps__item');
        this.back = document.querySelector('#back'),
        this.next = document.querySelector('#next'),
        this.menu = document.querySelector('#menu'),
        this.stepBtn = document.querySelector('.sidebar__menu a:last-child #step__title'),
        this.sidebarMenu = document.querySelector('.sidebar__menu');
        this.listeners();
        $('select').niceSelect(); //niceselect
        window.addEventListener('html_rendered', this.UIListeners, {once: true});
        this.navigationElements();
        ui.createHTML();
        return this;
    },
    navigationElements() {
        ui.back.addEventListener('click', () => {
            if (ui.sidebarContainer.classList.contains('component-information') || ui.sidebarContainer.querySelector('.sidebar__content__header__icon.active')) {
                ui.sidebarContainer.classList.remove('component-information');
            } else {
                this.step -= 1;
            }
            this.menu.classList.remove('active');
            ui.createHTML(this.step);
            if (this.step == 1) {
                ui.back.classList.add('disable');
            }
        });

        ui.next.addEventListener('click', () => {
            if (this.steps.length > this.step) {
                if(this.step === 3){
                    canvasPluginExtend.clearTransformers();
                    window.dispatchEvent(new CustomEvent('screenshot_look'));
                }

                //submit order step : check if order can process
                if (this.step === 4 && !window.order.validate(window.settings.settings)) {
                    return;
                }
                if (this.step === 4) {
                    if (window.order.validate(window.settings.settings) === true) {
                        window.dispatchEvent(new CustomEvent('screenshot_prepare'));
                    }
                    return;
                }
                this.step += 1;
                ui.back.classList.remove('disable');
                this.menu.classList.remove('active');
                ui.createHTML(this.step);
            }
        });

        ui.menu.addEventListener('click', (e) => {
            let target = e.target;
            this.animate(ui.sidebarContainer);
            if (target && target.classList.contains('active')) {
                ui.sidebarContainer.classList.remove('component-information');
                ui.createHTML(this.step);
                if (this.step == 1) {
                    ui.back.classList.add('disable');
                }
            } else {
                ui.createHTML('menu');
                ui.sidebarContainer.classList.add('component-information');
            }
            target.classList.toggle('active');
        });
    },
    sidebarPreloaderStart() {
        //step preloader
        ui.animate(ui.sidebarContainer);
        ui.sidebarPreloader.classList.remove('hidden');
    },
    sidebarPreloaderStop() {
        //remove step preloader
        ui.animate(ui.sidebarContainer);
        ui.sidebarPreloader.classList.add('hidden');
        ui.step += 1;
        ui.createHTML(ui.step);
    },
    animate(el) {
        el.animate([{
            opacity: '0.1'
        }, {
            opacity: '1'
        }], {
            duration: 350
        });
    },
    createHTML(step = 1) {
        ui.sidebarContainer.setAttribute('data-current', step);

        this.animate(ui.sidebarContainer);

        this.steps.forEach(item => {
            item.dataset.step == step ? item.classList.remove('hidden') : item.classList.add('hidden');
            if (item.getAttribute('data-step') == step) {
                if (step == "menu") return;
                this.stepBtn.innerHTML = item.getAttribute('btn-title');
                this.sidebarMenu.classList.remove('hidden');
                ui.sidebarContainer.classList.remove('full');
                this.next.classList.remove('active');
                if (step == this.steps.length) {
                    this.sidebarMenu.classList.add('hidden');
                    ui.sidebarContainer.classList.add('full');
                }
                if (window.innerWidth < 768 && step == 4) {
                    ui.configurator.classList.add('hidden');
                    ui.main.classList.add('sidebar__full');
                } else {
                    ui.configurator.classList.remove('hidden');
                    ui.main.classList.remove('sidebar__full');
                }
                if (step == 4) {
                    this.next.classList.add('active');
                }
            }
        });
        ui.closeAllPickers();
        document.querySelector('.sidebar__content .steps__item:not(.hidden)').scrollTop = 0;
        document.querySelector('.sidebar__content .sidebar__content__box').scrollTop = 0;
        window.dispatchEvent(new CustomEvent('html_rendered'));

        if (step != 1) {
            this.returnParams(this.step);
        }
    },
    initFrame() {
        let iframe = document.querySelector('.configurator iframe');
        let src = iframe.dataset.src;
        iframe.setAttribute('src', src);
    },
    sendMenuToggleEvent(id, isActive) {
        let detail = {
            id,
            isActive
        };
        
        window.dispatchEvent(new CustomEvent('menu_toggle_switched', {
            detail
        }));
    },
    switchTab(tabs, contentContainer, index) {
        tabs.forEach(item => item.dataset.tab != index ? item.classList.remove('active') : item.classList.add('active'));
        contentContainer.forEach(item => {
            item.classList.add('hidden')
            if (item.dataset.tab == index) {
                item.classList.remove('hidden');
                ui.animate(item.parentNode);
            }
        });
    },
    dropZone() {
        // dropzone for canvas
        new Dropzone("#canvas1", {
            maxFilesize: 5,
            addRemoveLinks: true,
            dictResponseError: 'Server not Configured',
            acceptedFiles: ".png,.jpg,.gif,.jpeg,.svg",
            autoProcessQueue: false,
            init: function () {
                let self = this;
                // config
                self.options.addRemoveLinks = true;
                self.options.dictRemoveFile = "Delete";
                //New file added
                self.on("addedfile", function (file) {
                    if (self.files.length >= 1) {
                        canvasPluginExtend.addImage(file);
                    }
                });
            },
        });
        new Dropzone("#canvas2", {
            maxFilesize: 5,
            addRemoveLinks: true,
            dictResponseError: 'Server not Configured',
            acceptedFiles: ".png,.jpg,.gif,.jpeg,.svg",
            autoProcessQueue: false,
            init: function () {
                let self = this;
                // config
                self.options.addRemoveLinks = true;
                self.options.dictRemoveFile = "Delete";
                //New file added
                self.on("addedfile", function (file) {
                    if (self.files.length >= 1) {
                        canvasPluginExtend.addImage(file);
                    }
                });
            },
        });
        Dropzone.autoDiscover = false;
    },
    colorPickerTools(item, index) {
        //change type
        item.querySelectorAll('.boxPicker__inputes__type .nice-select .option').forEach(el => {
            el.addEventListener('click', () => {
                let event = new Event('input', {
                    bubbles: true,
                    cancelable: true,
                });
                item.querySelector('.boxPicker__inputes__type select').dispatchEvent(event);
            });
        });

        item.querySelector(`#canvas${index+1}__color__type`).addEventListener('input', (e) => {
            let rgbInputes = item.querySelector('.boxPicker__inputes__items__rgb'),
                hexInput = item.querySelector('.boxPicker__inputes__items__hex');
            ui.animate(item);
            if (e.target.value == "HEX") {
                hexInput.classList.add('hidden');
                rgbInputes.classList.remove('hidden');
            } else {
                hexInput.classList.remove('hidden');
                rgbInputes.classList.add('hidden');
            }
        });
    },
    colorPicker() {
        document.querySelectorAll('.open-colour-picker').forEach(item => {
            item.addEventListener('click', () => {
                if (item.previousElementSibling.classList.contains('boxPicker')) {
                    item.previousElementSibling.classList.toggle('active');
                    item.classList.toggle('active');
                } 
            })
        });
        document.querySelectorAll('.boxPicker').forEach((item, index) => {
            ui.colorPickerTools(item, index);
            var colorP = new iro.ColorPicker(item, {
                width: 335,
                color: "#dfaeae",
                borderWidth: 1,
                borderColor: "#fff",
                padding: 0,
                handleSvg: '#handle',
                handleProps: {x: -8, y: -8},
                layout: [{
                        component: iro.ui.Box,
                    },
                    {
                        component: iro.ui.Slider,
                        options: {
                            id: 'hue-slider',
                            sliderType: 'hue',
                            handleSvg: '#handle',
                            width: 295
                        }
                    }
                ]
            }); 
            colorP.on('input:end', function (color) {
                let newColor = color.rgbString.replace(/[^\d,]/g, '').split(',');
                item.querySelectorAll('.boxPicker__inputes__items__rgb input').forEach((item, index) => item.value = newColor[index]);
                item.querySelector('.boxPicker__inputes__items__hex input').value = color.hexString.replace('#', '');

                item.querySelector('.canvas__tab-color_rgb').value = color.rgbString;
                item.querySelector('.canvas__tab-color_rgb').dispatchEvent(new Event('change'));
            });
        });
    },
    closeAllPickers() {
        document.querySelectorAll('.open-colour-picker.active').forEach(item => item.classList.remove('active'));
        document.querySelectorAll('.boxPicker.active').forEach(item => item.classList.remove('active'));
    },
    UIListeners() {
        // menu toggle
        document.querySelectorAll('.menu__content_func__item').forEach(item => {
            item.addEventListener('click', function () {
                this.classList.toggle(activeClass);
                ui.sendMenuToggleEvent(this.id, this.classList.contains(activeClass));
            });
        });

        // изменение цвета в елементе
        document.querySelectorAll('.colours__item').forEach(item => {
            item.addEventListener('click', () => {
                if (!ui.sidebarContainer.querySelector('.sidebar__content__box').classList.contains('information')) {
                    let header = item.parentNode.previousElementSibling;
                    header.querySelector('#color-key').style.background = item.style.background;
                    header.querySelector('#color-key-name').innerText = item.getAttribute('data-colour-name');
                    //color types sync
                    ['key', 'court', 'runoff'].forEach(type => {
                        if (header.classList.contains(`colour-${type}`)) {
                            window.settings.settings.colours[type] = {
                                name: item.getAttribute('data-colour-name'),
                                colour: item.getAttribute('color')
                            }
                        }
                    });
                }
            });
        });

        // переход по табам
        document.querySelectorAll('.tabs__item').forEach(item => {
            item.addEventListener('click', () => {
                ui.switchTab(item.parentNode.querySelectorAll('div'), item.closest('.tabs').querySelectorAll('.tabs__content > div'), item.dataset.tab);
                ui.closeAllPickers();
            });
        });

        document.querySelectorAll('.tabs__content__item__tools__tabs__item').forEach(item => {
            item.addEventListener('click', (e) => {
                ui.switchTab(item.parentNode.querySelectorAll('a'), item.closest('.tabs__content__item__tools').querySelectorAll('.tabs__content__item__tools__content > div'), item.dataset.tab);
                ui.closeAllPickers();
            });
        });

        // dropzone
        ui.dropZone();

        // colorPicker
        ui.colorPicker();

        // Переход по пунктах меню
        document.querySelectorAll('.sidebar__content .menu__content__box h3').forEach(item => {
            item.addEventListener('click', () => {
                ui.sidebarContainer.classList.remove('component-information');
                ui.step = parseInt(item.getAttribute('data-open-step'));
                ui.menu.classList.remove('active');
                ui.step == 1 ? ui.back.classList.add('disable') : ui.back.classList.remove('disable');
                ui.createHTML(ui.step);
            });
        });
    },
    listeners() {
        window.addEventListener('app_order_process', ui.sidebarPreloaderStart)
        window.addEventListener('app_order_finished', ui.sidebarPreloaderStop);
        window.addEventListener('screenshot_look_ready', ui.updateScreenshotPreview);
        this.initFrame();
    },
    updateScreenshotPreview(e){
        document.querySelector('.screenshot').src = e.detail;
    },
    returnParams(step) {
        if (step == 2) {
            let searchParams = new URLSearchParams(window.location.search);

            let colorFirst = searchParams.get('col1'),
                colorSecond = searchParams.get('col2');

            let colorEl = ui.sidebarContainer.querySelector(`.colour-key + .colours [color="${colorFirst}"]`);
            if(colorEl){
                colorEl.click();
            }

            colorEl = ui.sidebarContainer.querySelector(`.colour-court + .colours [color="${colorSecond}"]`);
            if(colorEl){
                colorEl.click();
            }
        }
    },
};